import API from "./axios";

export const login = async (email, password, subadmin = false, ca = false, superadmin = false) => {
  try {
    const response = await API.post("/auth/login", { email, password, subadmin, ca, superadmin });
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Login failed";
  }
};

export const register = async (userData) => {
  try {
    const response = await API.post("/auth/register", userData);
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Registration failed";
  }
};

export const checkMobileExistence = async (mobile) => {
  try {
    const response = await API.get(`/auth/check-mobile/${mobile}`);
    return response.data.exists;
  } catch (error) {
    console.error('Error checking mobile existence:', error);
    return false;
  }
};

export const checkEmailExistence = async (email) => {
  try {
    const response = await API.get(`/auth/check-email/${email}`);
    return response.data.exists;
  } catch (error) {
    console.error('Error checking email existence:', error);
    return false;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await API.get("/auth/me");
    console.log('getCurrentUser response:', response.data);
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Failed to fetch user";
  }
};

export const logout = async () => {
  try {
    await API.post("/auth/logout");
  } catch (error) {
    throw error.response.data.message || "Logout failed";
  }
};
